import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'
import { siteBoundarySchema } from './geo.dto.js'

/**
 * A named ring inside a site.
 *
 * An area is not a tag shared across the company. The name is a label on this
 * ring. Another ring on the same site may carry the same words — two
 * courtyards can both be "Common Area" — and renaming one leaves the other
 * as it was. Suggestions while typing are just the names already used here.
 */
export const areaDtoSchema = z.object({
  id: uuidSchema,
  siteId: uuidSchema,
  name: z.string(),
  boundary: siteBoundarySchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type AreaDto = z.infer<typeof areaDtoSchema>

export const areaListDtoSchema = z.object({
  areas: z.array(areaDtoSchema),
})

export type AreaListDto = z.infer<typeof areaListDtoSchema>